import {ElementRef, Injectable, Renderer2} from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {ConfigService} from 'app/core/services/config.service';

@Injectable()
export class UtilService {

    static readonly PATTERN_EMAIL = `(?:[a-zA-Z0-9+_-]+(?:\\.[a-zA-Z0-9+=?_-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])`;
    // static readonly PATTERN_EMAIL = /\S+@\S+\.\S+/;

    static readonly PATTERN_URL = ('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$') // fragment locator

    static readonly HTTP_URL = 'https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,4}\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)';

    static readonly PATTERN_ASCII = /^[ -~]+$/;
    private isInProgressObserver = new Subject<boolean>();
    public isInProgress$ = this.isInProgressObserver.asObservable();


    private bodyElement: any;
    private footerElement: any;
    private navbarElement: any;
    private containerElement: any;
    private loaderContainerElement: any;
    private alertElement: any;

    renderer: Renderer2;
    elementRef: ElementRef;

    constructor(
        private configService: ConfigService
    ) { }

    hidePartials(backgroundImageUrl?: string) {
        // change body
        this.renderer.addClass(document.body, 'login-body');
        this.renderer.removeClass(document.body, 'general-body');
        if (backgroundImageUrl) this.renderer.setStyle(document.body, 'background-image', 'url(' + backgroundImageUrl + ')');
        this.renderer.setStyle(document.body, 'background-size', 'cover');

        // change HTML
        this.renderer.addClass(document.body.parentElement, 'login-html');
        this.renderer.removeClass(document.body.parentElement, 'general-html')
        this.loaderContainerElement = this.elementRef.nativeElement.querySelectorAll('.global-loader-container')[0];
        this.containerElement = this.loaderContainerElement.firstElementChild;
        this.alertElement = this.containerElement.firstElementChild;
        this.footerElement = this.elementRef.nativeElement.getElementsByTagName('itpx-footer')[0];
        this.navbarElement = this.elementRef.nativeElement.firstElementChild;
        this.renderer.addClass(this.containerElement, 'login-container');
        this.renderer.removeClass(this.containerElement, 'container');
        this.renderer.addClass(this.loaderContainerElement, 'login-container');
        this.renderer.removeClass(this.loaderContainerElement, 'global-loader-container');

        this.footerElement.style.display = 'none';
        this.navbarElement.style.display = 'none';
        this.alertElement.style.display = 'none';
    }

    showPartials() {

        this.renderer.addClass(document.body, 'general-body');
        this.renderer.removeClass(document.body, 'login-body');
        this.renderer.removeStyle(document.body, 'background-image');

        // // change HTML
        this.renderer.addClass(document.body.parentElement, 'general-html');
        this.renderer.removeClass(document.body.parentElement, 'login-html');


        this.renderer.addClass(this.containerElement, 'container');
        this.renderer.removeClass(this.containerElement, 'login-container');
        this.renderer.addClass(this.loaderContainerElement, 'global-loader-container');
        this.renderer.removeClass(this.loaderContainerElement, 'login-container');

        this.navbarElement.style.display = 'block';
        this.footerElement.style.display = 'block';
        this.alertElement.style.display = 'block';
    }

    hideBackgroundImage() {
        this.renderer.removeStyle(document.body, 'background-image');
    }

    reload(): void {
        window.location.reload();
    }

    startProgress() {
        this.isInProgressObserver.next(true);
    }

    endProgress() {
        this.isInProgressObserver.next(false);
    }

    flatten(obj: any): any {
        const toReturn = {};

        for (const key in obj) {
            if (!obj.hasOwnProperty(key)) {
                continue;
            }
            if ((typeof obj[key]) === 'object' && !(obj[key] instanceof Array)) {
                const flatObject = this.flatten(obj[key]);
                for (const key2 in flatObject) {
                    if (!flatObject.hasOwnProperty(key2)) {
                        continue;
                    }

                    toReturn[key + '.' + key2] = flatObject[key2];
                }
            } else {
                toReturn[key] = obj[key];
            }
        }
        return toReturn;
    }

    unflatten(obj: any) {
        let result = {};
        for (let property in obj) {
            if (obj.hasOwnProperty(property))
                if (property.indexOf('.') !== -1) {
                    if (obj[property] || obj[property] === 0) {
                        this.parseDotNotation(property, obj[property], result);
                    }
                } else {
                    result[property] = obj[property];
                }
        }
        return result;
    }

    // Traverses Object and trims string values
    trim(obj: any) {
        let result;
        if (typeof (obj) === 'object') {
            result = {};
            if (obj instanceof Array)
                result = [];
            for (let key in obj) {
                let value = obj[key];
                if (value !== null && typeof (value) === 'object') {
                    //going one step down in the object tree!!
                    result[key] = this.trim(value);
                } else {
                    if (typeof value === 'string') {
                        value = value.trim();
                    }
                    result[key] = value;
                }
            }
        } else {
            if (typeof obj === 'string') {
                result = obj.trim();
            } else {
                result = obj;
            }
        }
        return result;
    }

    private parseDotNotation(str: string, val: any, obj: any) {
        let currentObj = obj,
            keys = str.split('.'),
            i, l = Math.max(1, keys.length - 1),
            key;

        for (i = 0; i < l; ++i) {
            key = keys[i];
            currentObj[key] = currentObj[key] || {};
            currentObj = currentObj[key];
        }

        currentObj[keys[i]] = val;
    }

    guid() {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
    // removing  multiple slashes from url first && preceeding http,https and www from URL string
    remove_http(url) {
        return url.replace(/\/+/g, "/").replace(/\/$/, '').replace(/^(?:https?:\/\/)?(?:www\.)?/i, '');
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/util.service.ts